export namespace DomUtility {
    export async function imagesLoaded(el: HTMLElement, timeout: number = 2000): Promise<string[]> {
        const promises: Promise<string>[] = [];
        const imageElements: NodeListOf<HTMLImageElement> = el.querySelectorAll<HTMLImageElement>('img');
        imageElements.forEach((imageEl: HTMLImageElement) => {
            promises.push(imageLoaded(imageEl, timeout));
        });

        return Promise.all(promises);
    }
    export async function imageLoaded(imageEl: HTMLImageElement, timeout: number = 2000): Promise<string> {
        const loadingPromise: Promise<string> = new Promise((resolve: Function, reject: Function) => {
            if(imageEl.complete || imageEl.getAttribute('loading') != 'lazy') {
                resolve();
            } else {
                imageEl.addEventListener('load', () => {
                    resolve();
                }, { once: true });
                imageEl.addEventListener('error', () => {
                    reject();
                }, { once: true });
            }
            window.setTimeout(() => {
                resolve();
            }, timeout);
        });
        return loadingPromise;
    }
}
